import { X } from "lucide-react";
import { countryName } from "@/lib/countries";

const selectCls = "h-11 px-3 bg-white border border-[#E5DCCB] rounded-full text-sm focus:outline-none focus:border-[#8B3A2B] min-w-0 flex-1 sm:flex-none sm:w-52";

const uniq = (arr) => [...new Set(arr.filter(Boolean))];

export const UserFacetFilters = ({ users, school, country, onSchool, onCountry }) => {
  const schools = uniq(users.map((u) => u.school)).sort((a, b) => a.localeCompare(b, "ar"));
  const countries = uniq(users.map((u) => u.country)).map((c) => ({ c, n: countryName(c) })).sort((a, b) => a.n.localeCompare(b.n, "ar"));
  return (
    <div className="flex flex-wrap items-center gap-2 mb-4" data-testid="admin-facet-filters">
      <select value={school} onChange={(e) => onSchool(e.target.value)} className={selectCls} data-testid="admin-filter-school" aria-label="تصفية بالمدرسة">
        <option value="">كل المدارس</option>
        {schools.map((s) => <option key={s} value={s}>{s}</option>)}
      </select>
      <select value={country} onChange={(e) => onCountry(e.target.value)} className={selectCls} data-testid="admin-filter-country" aria-label="تصفية بالدولة">
        <option value="">كل الدول</option>
        {countries.map(({ c, n }) => <option key={c} value={c}>{n}</option>)}
      </select>
      {(school || country) && (
        <button onClick={() => { onSchool(""); onCountry(""); }} data-testid="admin-filter-clear"
          className="w-full sm:w-auto justify-center inline-flex items-center gap-1 h-11 px-4 rounded-full text-sm text-[#8B3A2B] hover:bg-[#F2ECE1] transition-colors">
          <X className="w-4 h-4" /> إلغاء التصفية
        </button>
      )}
    </div>
  );
};
